var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-main',[_c('el-alert',{attrs:{"title":"导入失败","type":"error","center":"","show-icon":"","description":_vm.message}}),_vm._v(" "),_c('p',{staticClass:"f-tac"},[_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("重新导入")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66bca0de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/inquiry/import/index.vue
// module id = null
// module chunks = 